import { toast } from 'react-toastify';

export default () => (next) => (action) => {
    // If not a promise, continue on
    if (!(action.payload instanceof Promise)) {
        return next(action);
    }

    /**
     *
     * The error middleware serves to dispatch the initial pending promise to
     * the promise middleware, but adds a `catch`.
     * It need not run in production
     */
    // if (process.env.NODE_ENV === 'development') {
    // Dispatch initial pending promise, but catch any errors
    return next(action).catch((error) => {
        console.error(`${action.type} caught at middleware with reason: ${JSON.stringify(error.message)}.`);
        if (error && error.response) {
            const resp = error.response;
            const msg =
                resp.data?.uk ||
                (resp.data?.locales && resp.data?.locales?.uk) ||
                (Array.isArray(resp.data?.message) ? resp.data?.message.join(', ') : resp.data?.message) ||
                resp.statusText;
            console.error(`Actual cause: ${msg}`);
            if (!error.config.headers.SkipError && msg) {
                toast.error(msg);
            }
        }
        return Promise.reject(error);
    });
    // }
    // return next(action);
};
